import { render, staticRenderFns } from "./ContractInsurance.vue?vue&type=template&id=537757b4&scoped=true"
import script from "./ContractInsurance.vue?vue&type=script&lang=js"
export * from "./ContractInsurance.vue?vue&type=script&lang=js"
import style0 from "./ContractInsurance.vue?vue&type=style&index=0&id=537757b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537757b4",
  null
  
)

export default component.exports